/**
 * Version 1 customer-facing pricing constants.
 *
 * Single source of truth for every price string shown to customers.
 * Professional AI Review is a fixed price; Full-Service Negotiation is quoted
 * after the review, with a labeled estimate range and disclaimer on the
 * selection page so the customer understands the service before speaking with a
 * specialist.
 */

/** Professional AI Review price (USD). */
export const REVIEW_PRICE = 4.99;

/** Formatted Professional AI Review price. */
export const REVIEW_PRICE_LABEL = "$4.99";

/** FastTrack Professional AI Review price (USD). */
export const FASTTRACK_PRICE = 99;

/** Formatted FastTrack price. */
export const FASTTRACK_PRICE_LABEL = "$99";

/** Customer-facing label used anywhere a negotiation price would appear. */
export const NEGOTIATION_PRICE_LABEL = "Pricing After Specialist Review";

/** Short explanation shown next to the negotiation price label. */
export const NEGOTIATION_PRICING_NOTE =
  "Every claim is unique. After reviewing your completed AI Findings Report, one of our negotiation specialists will evaluate your case and provide personalized pricing before any work begins. There is never any obligation to proceed.";

/** Compact one-line version of the pricing note for tight layouts. */
export const NEGOTIATION_PRICING_NOTE_SHORT =
  "Personalized pricing after a specialist reviews your AI Findings Report. No obligation to proceed.";

/** Longer explanation of how Full-Service Negotiation works. */
export const NEGOTIATION_SERVICE_NOTE =
  "Full-Service Negotiation is handled by experienced negotiation specialists after your Professional AI Review. Once your findings are ready, a specialist evaluates your case and provides personalized pricing before any work begins.";

/** Headline shown inside the Full-Service Negotiation pricing block. */
export const NEGOTIATION_TYPICAL_RANGE_LABEL = "Pricing After Specialist Review";

/** Detailed pricing explanation shown for Full-Service Negotiation. */
export const NEGOTIATION_PRICING_ESTIMATE_DISCLAIMER =
  "Standard Specialist Review: $450 per file. Success Fee: 25% of the savings we recover through negotiation. You'll receive a personalized proposal after our specialist reviews your AI Findings Report. No negotiation work begins until you approve the pricing. There is no obligation to proceed.";


/** Formats a customer-facing USD amount. */
export function formatPrice(amount: number): string {
  return `$${amount.toFixed(2).replace(/\.00$/, "")}`;
}
